import React from 'react'
import OneMapApi from '@jarvis.oddle/core/api/map/onemap'
import MapResource from '@jarvis.oddle/core/components/MapResource'

export const flow = {
  initial: 'start',
  states: {
    start: {
      on: {
        SHOW_DROPDOWN: 'dropdown'
      }
    },
    dropdown: {
      on: {
        CLOSE_DROPDOWN: 'start',
        SELECT_ADDRESS: 'addressTwo'
      }
    },
    addressTwo: {
      on: {
        RESET: 'start',
        QUERY_CLEAR: 'start',
        SHOW_DROPDOWN: 'dropdown'
      }
    }
  }
}

const oneMapResources = {
  MapComponent: null,
  ...OneMapApi()
}

const OneMapService = ({ children }: { children? }): JSX.Element => {
  return (
    <MapResource {...oneMapResources}>
      {(mapResourceProps) => children({ flow, ...mapResourceProps })}
    </MapResource>
  )
}

export default OneMapService
